import script from "./UnsavedChangesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UnsavedChangesModal.vue?vue&type=script&setup=true&lang=js"

import "./UnsavedChangesModal.vue?vue&type=style&index=0&id=429e447e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-429e447e"]])

export default __exports__